"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const crypto = require("crypto");
class SecurityManager {
    constructor(endpointSecret) {
        this._endpointSecret = endpointSecret;
    }
    /**
     * @see https://api-reference.kevin.eu/public/platform/v0.3#tag/Signature
     */
    verifySignature(requestBody, requestHeaders, webhookUrl, timestampTimeout) {
        const kevinSignatureHeader = this.findValueByCaseInsensitiveKey(requestHeaders, 'x-kevin-signature');
        const kevinTimestampHeader = this.findValueByCaseInsensitiveKey(requestHeaders, 'x-kevin-timestamp');
        if (!kevinSignatureHeader || !kevinTimestampHeader) {
            return false;
        }
        if (!!timestampTimeout && timestampTimeout < (Date.now() - Number(kevinTimestampHeader))) {
            return false;
        }
        if (typeof requestBody === 'object') {
            requestBody = JSON.stringify(requestBody);
        }
        const data = `POST${webhookUrl}${kevinTimestampHeader}${requestBody}`;
        const signature = crypto.createHmac('SHA256', this._endpointSecret).update(data).digest('hex');
        return signature === kevinSignatureHeader;
    }
    findValueByCaseInsensitiveKey(haystack, needle) {
        const match = Object.keys(haystack).find(key => key.toLowerCase() === needle.toLowerCase());
        if (!match) {
            return undefined;
        }
        return haystack[match];
    }
}
exports.default = SecurityManager;
